// lib/api.ts
import axios from "axios";

const API_BASE_URL = "https://api.ecosafe.com.sa/api";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000, // 10 second timeout
});

// Simple response interceptor for basic error logging
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log server errors
    if (error.response?.status >= 500) {
      console.error("Server error:", error.response.data);
    }

    // Log timeout errors
    if (error.code === "ECONNABORTED") {
      console.error("Request timeout");
    }

    return Promise.reject(error);
  }
);

export default api;
